var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.12 2.91C13.58 2.91 2.91 14.55 2.91 28.12C2.91 127.03 2.91 412.12 2.91 511.03C2.91 524.61 14.55 536.24 28.12 536.24C49.26 536.24 218.38 536.24 239.52 536.24C235.64 583.76 202.67 598.3 162.91 624.48C157.09 628.36 160 638.06 166.79 638.06C197.33 638.06 441.7 638.06 472.24 638.06C479.03 638.06 481.94 628.36 476.12 624.48C436.36 598.3 403.39 582.79 399.52 536.24C420.65 536.24 589.77 536.24 610.91 536.24C625.45 536.24 636.12 525.58 636.12 511.03C636.12 412.12 636.12 127.03 636.12 28.12C638.06 13.58 626.42 2.91 611.88 2.91C495.13 2.91 86.5 2.91 28.12 2.91ZM191.03 622.55C210.42 609.94 250.18 588.61 254.06 535.27C267.15 535.27 371.88 535.27 384.97 535.27C389.82 589.58 428.61 609.94 448.97 622.55C397.38 622.55 216.82 622.55 191.03 622.55ZM28.12 17.45C86.5 17.45 553.5 17.45 611.88 17.45C617.7 17.45 622.55 22.3 622.55 28.12C622.55 56.37 622.55 197.62 622.55 451.88L17.45 451.88L17.45 28.12C20.69 21.01 24.24 17.45 28.12 17.45ZM612.85 521.7C554.38 521.7 86.59 521.7 28.12 521.7C22.3 521.7 17.45 516.85 17.45 511.03C17.45 508.06 17.45 493.19 17.45 466.42L623.52 466.42L623.52 511.03C620.28 518.14 616.73 521.7 612.85 521.7Z",
    id: "a1nDr1dQlT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48 39.76C44.61 39.76 40.73 42.67 40.73 47.52C40.73 85.04 40.73 385.26 40.73 422.79C40.73 426.67 43.64 430.55 48.48 430.55C102.79 430.55 537.21 430.55 591.52 430.55C595.39 430.55 599.27 427.64 599.27 422.79C599.27 385.16 599.27 84.17 599.27 46.55C599.27 42.67 595.39 39.76 591.52 39.76C482.91 39.76 102.79 39.76 48.48 39.76ZM56.24 415.03L56.24 54.3L584.73 54.3L584.73 415.03L56.24 415.03Z",
    id: "bkzIddAGv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.15 381.09C162.52 381.09 477.48 381.09 516.85 381.09C525.58 381.09 533.33 374.3 533.33 365.58C533.33 339.39 533.33 129.94 533.33 103.76C533.33 95.03 526.55 88.24 516.85 88.24C477.48 88.24 162.52 88.24 123.15 88.24C114.42 88.24 106.67 95.03 106.67 103.76C106.67 259.88 106.67 212.36 106.67 365.58C106.67 374.3 113.45 381.09 123.15 381.09ZM123.15 366.55C122.18 366.55 121.21 365.58 121.21 365.58C121.21 353.62 121.21 293.82 121.21 186.18L517.82 186.18C517.82 293.82 517.82 353.62 517.82 365.58C518.79 365.58 517.82 366.55 516.85 366.55C438.11 366.55 162.52 366.55 123.15 366.55ZM516.85 102.79C517.82 102.79 518.79 103.76 518.79 103.76C518.79 108.28 518.79 130.91 518.79 171.64L121.21 171.64C121.21 130.91 121.21 108.28 121.21 103.76C121.21 102.79 122.18 102.79 123.15 102.79C201.89 102.79 477.48 102.79 516.85 102.79Z",
    id: "c7AT9HuG4k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.03 137.7C191.03 122.18 178.42 110.55 162.91 110.55C147.39 110.55 134.79 123.15 134.79 137.7C134.79 152.24 147.39 164.85 162.91 164.85C178.42 164.85 191.03 152.24 191.03 137.7ZM176.48 137.7C176.48 144.48 170.67 150.3 162.91 150.3C155.15 150.3 149.33 144.48 149.33 137.7C149.33 130.91 155.15 125.09 162.91 125.09C170.67 125.09 176.48 130.91 176.48 137.7Z",
    id: "a5Yh39wzUd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79 137.7C262.79 122.18 250.18 110.55 234.67 110.55C219.15 110.55 206.55 123.15 206.55 137.7C206.55 152.24 219.15 164.85 234.67 164.85C250.18 164.85 262.79 152.24 262.79 137.7ZM248.24 137.7C248.24 144.48 242.42 150.3 234.67 150.3C226.91 150.3 221.09 144.48 221.09 137.7C221.09 130.91 227.88 125.09 234.67 125.09C242.42 125.09 248.24 130.91 248.24 137.7Z",
    id: "auEsVWL92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.88 144.48C487.76 144.48 491.64 141.58 491.64 136.73C491.64 131.88 488.73 128.97 483.88 128.97C464.39 128.97 308.46 128.97 288.97 128.97C285.09 128.97 281.21 131.88 281.21 136.73C281.21 141.58 285.09 144.48 288.97 144.48C327.95 144.48 464.39 144.48 483.88 144.48Z",
    id: "a2D5cPjYS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.97 213.33C285.09 213.33 281.21 216.24 281.21 221.09C281.21 225.94 284.12 228.85 288.97 228.85C308.46 228.85 464.39 228.85 483.88 228.85C487.76 228.85 491.64 225.94 491.64 221.09C491.64 216.24 487.76 213.33 483.88 213.33C444.9 213.33 308.46 213.33 288.97 213.33Z",
    id: "k9Gepw07SM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.48 277.33C436.36 277.33 440.24 274.42 440.24 269.58C440.24 264.73 437.33 261.82 432.48 261.82C418.13 261.82 303.32 261.82 288.97 261.82C285.09 261.82 281.21 264.73 281.21 269.58C281.21 274.42 285.09 277.33 288.97 277.33C317.67 277.33 418.13 277.33 432.48 277.33Z",
    id: "ek6fkjH5Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.97 312.24C285.09 312.24 281.21 315.15 281.21 320C281.21 324.85 284.12 327.76 288.97 327.76C305.84 327.76 440.82 327.76 457.7 327.76C461.58 327.76 465.45 324.85 465.45 320C465.45 315.15 460.61 312.24 456.73 312.24C423.18 312.24 305.75 312.24 288.97 312.24Z",
    id: "e8HPLZGKFk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15 213.33C151.27 213.33 147.39 216.24 147.39 221.09C147.39 230.88 147.39 309.24 147.39 319.03C147.39 322.91 150.3 326.79 155.15 326.79C165.24 326.79 245.92 326.79 256 326.79C259.88 326.79 263.76 323.88 263.76 319.03C263.76 309.24 263.76 230.88 263.76 221.09C262.79 217.21 259.88 213.33 256 213.33C235.83 213.33 165.24 213.33 155.15 213.33ZM161.94 311.27L161.94 227.88L248.24 227.88L248.24 311.27L161.94 311.27Z",
    id: "bkEhriMPU"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1nDr1dQlT",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1nDr1dQlT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bkzIddAGv",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bkzIddAGv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c7AT9HuG4k",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c7AT9HuG4k",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5Yh39wzUd",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5Yh39wzUd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#auEsVWL92",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#auEsVWL92",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2D5cPjYS",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2D5cPjYS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k9Gepw07SM",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k9Gepw07SM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ek6fkjH5Y",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ek6fkjH5Y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e8HPLZGKFk",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e8HPLZGKFk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bkEhriMPU",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bkEhriMPU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBanner);
export default __webpack_public_path__ + "static/media/email-banner.b3b976d96b560cec1b81b287e43387ce.svg";
export { ForwardRef as ReactComponent };